// @flow
import React from 'react';
import {Field, reduxForm} from 'redux-form';
import SelectFormInput from '../SelectFormInput/SelectFormInput';
import TextAreaFormInput from '../TextAreaFormInput/TextAreaFormInput';
import DecimalFormInput from '../DecimalFormInput/DecimalFormInput';

const LinkedAdditionalRowForm = () => (
  <div className="LinkedAdditionalRowForm">
    <Field
      name="product"
      label="Produkt"
      disabled={true}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={[]} />
    <Field
      name="productVariant"
      label="Variant"
      disabled={true}
      deleteRemoves={false}
      component={SelectFormInput}
      valueKey="id"
      labelKey="name"
      options={[]} />
    <Field
      name="quantity"
      label="Antal"
      component={DecimalFormInput} />
    <Field
      name="note"
      label="Anteckning"
      component={TextAreaFormInput} />
  </div>
);

export default reduxForm({
  form: 'linkedAdditionalRow',
  enableReinitialize: true,
})(LinkedAdditionalRowForm);



// WEBPACK FOOTER //
// ./src/components/LinkedAdditionalRowForm/LinkedAdditionalRowForm.js